export default {
  searchText: '',
  orderName: 'created_at',
  sortAsc: false,
  isValid: 0,
  machineType: null
}
